import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7002700a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7002700a')) {
      api.createRecord('7002700a', component.options)
    } else {
      api.reload('7002700a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7002700a&", function () {
      api.rerender('7002700a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListComponents/Histories/index.vue"
export default component.exports